import { render } from "./ClientCreateComponent.vue?vue&type=template&id=1fb093f1"
import script from "./ClientCreateComponent.vue?vue&type=script&lang=js"
export * from "./ClientCreateComponent.vue?vue&type=script&lang=js"

import "./ClientCreateComponent.vue?vue&type=style&index=0&id=1fb093f1&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__